export enum TLCode {
  Add,
  AddUser,
  Authorized,
  ByMail,
  ByPhone,
  ContactUs,
  Rejected,
  StartDate,
  EndDate,
  dummy,
  ALL,
  BackToList,
  BANK_HOLIDAY_DATES_Title,
  BANK_HOLIDAYS_Button,
  BLACKPOINT_Choose_Type,
  BLACKPOINT_Comment,
  BLACKPOINT_DETAIL_Approuved,
  BLACKPOINT_DETAIL_Days,
  BLACKPOINT_DETAIL_Refused,
  BLACKPOINT_DETAIL_Submitted,
  BLACKPOINT_EndDate,
  BLACKPOINT_Pharmacy,
  BLACKPOINT_Search_Date,
  BLACKPOINT_StartDate,
  BLACKPOINT_Title,
  BLACKPOINT_ToProcess,
  BLACKPOINT_Type,
  BlackPointPage,
  BLACKPOINTS_EmptyList,
  BLACKPOINTS_PageTitle,
  BLACKPOINTS_Title,
  BLACKPOINTS_TitleNoCriteria,
  BLACKPOINTS_TitleToProcessed,
  CHOOSE_A_GROUP,
  CHOOSE_A_LANGUAGE,
  CHOOSE_A_DAY,
  CHOOSE_A_PHARMACY,
  CHOOSE_A_SECRETARIAT,
  CHOOSE_A_TYPE,
  CHOOSE_A_USER,
  CHOOSE_A_STATUS,
  Duties,
  Days,
  Nights,
  DutiesBackToList,
  DutiesBetweenEnd,
  DutiesBetweenStart,
  DutiesHeaderAddress,
  DutiesHeaderDate,
  DutiesHeaderCity,
  DutiesHeaderZip,
  DutiesHeaderHourRange,
  DutiesHeaderPharmacyApbNumber,
  DutiesHeaderPharmacyName,
  DutiesHeaderPhoneNumber,
  DutiesMarkerTitle,
  DutiesShowOnMap,
  DutiesShowList,
  DutiesShowWideMap,
  DutiesShowCalendar,
  DUTIES_ShowOtherPharmacies,
  DUTIES_ShowPharmaciesDutyCircle,
  DUTIES_ShowPharmaciesDuty30KmCircle,
  DUTIES_ShowAnchors,
  DUTIES_ShowDayDuties,
  DUTIES_ShowNightDuties,
  DUTIES_ToggleSelectedGroups,
  DUTIES_CheckAllGroups,
  DUTIES_UncheckAllGroups,
  DUTIES_Duties,
  DUTYASSIGNMENT_AddDuty,
  DUTYASSIGNMENT_SaveDuties,
  DUTYASSIGNMENT_Date,
  DUTYASSIGNMENT_LEVEL1,
  DUTYASSIGNMENT_LEVEL3,
  DUTYASSIGNMENT_TOTAL,
  DUTYASSIGNMENT_DAY_OF_WEEK,
  DUTYASSIGNMENT_DAY,
  DUTYASSIGNMENT_DAY_ZONES,
  DUTYASSIGNMENT_DAY_ZONES2,
  DUTYASSIGNMENT_DAY_AND_NIGHT,
  DUTYASSIGNMENT_DutiesGeneration,
  DUTYASSIGNMENT_DutiesSamePeriod,
  DUTYASSIGNMENT_Next,
  DUTYASSIGNMENT_NIGHT,
  DUTYASSIGNMENT_NIGHT_ZONES,
  DUTYASSIGNMENT_NIGHT_ZONES2,
  DUTYASSIGNMENT_Pharmacy,
  DUTYASSIGNMENT_SelectPharmacy,
  DUTYASSIGNMENT_Title,
  DUTYASSIGNMENT_Type,
  DUTYASSIGNMENT_ViewOnlyNeighbor,
  DUTYASSIGNMENT_NotifySecretariat,
  DUTYUPLOAD_Title,
  DUTYDOWNLOAD_Title,
  DutyPage,
  DutySearchPage,
  DutyTypeDay,
  DutyTypeNight,
  Email,
  ERROR_NoPharmacyRelatedToThisUser,
  ERROR_NoSecretariatRelatedToThisUser,
  ERROR_PAGE_Title,
  ERROR_REQUIRED_FIELD,
  ERROR_VALUE_TOO_LONG,
  EXCHANGE_DUTIES_CARD_TITLE,
  EXCHANGE_DUTIES_OutsideList,
  EXCHANGE_DUTIES_AsTheCrowFlies,
  EXCHANGE_PHARMACY_OTHER_CARD_TITLE,
  EXCHANGE_PHARMACY_REQUESTER_CARD_TITLE,
  EXCHANGE_Title,
  EXCHANGE_HistoryTabTitle,
  EXCHANGE_HISTORY_Date,
  EXCHANGE_HISTORY_Sender,
  EXCHANGE_HISTORY_Recipient,
  EXCHANGE_HISTORY_DutyDate,
  EXCHANGE_HISTORY_DutyType,
  EXCHANGE_HISTORY_LoadPastDate,
  EXCHANGE_NewExchangeTabTitle,
  EXCHANGE_Remark,
  EXCHANGE_Preview,
  EXCHANGE_WithAgreementMessage,
  EXCHANGE_WithoutSubstitutionMessage,
  EXCHANGE_NeighborDutiesReinitialisation,
  EXCHANGE_WithAgreement,
  EXCHANGE_WithSubstitution,
  EXCHANGE_ConflictPharmacy,
  EXCHANGE_ConflictSecretariat,
  EXCHANGE_ConflictDutyDate,
  EXCHANGE_Save,
  ExchangePage,
  ExportAsPdf,
  Firstname,
  FORM_FIELD_REQUIRED_LABEL,
  FORM_FIELD_VALIDATION_REGEX,
  FORM_FIELD_VALIDATION_REQUIRED,
  FILE_UPLOAD_ERROR_MESSAGE,
  FILE_UPLOAD_SUCCESSFULLY_IMPORT,
  FILE_LOADING_MODAL_MUNICIPALITIES_TITLE,
  FILE_LOADING_MODAL_ZIP_CODE_TITLE,
  FILE_LOADING_MODAL_POPULATION_TITLE,
  GENERAL_Cancel,
  GENERAL_Refresh,
  GENERAL_Reset,
  GENERAL_Save,
  GENERAL_Send,
  GENERAL_Search,
  GENERAL_Select,
  GENERAL_Mark,
  GENERAL_ConfirmationDemand,
  GENERAL_Add,
  GENERAL_Delete,
  GENERAL_NextYear,
  GENERAL_Today,
  GENERAL_NextDay,
  GENERAL_PreviousDay,
  GENERAL_Validate,
  GENERAL_Warning,
  GENERAL_Print,
  GROUP,
  GROUP_Edit,
  GROUP_Add,
  GROUP_Name,
  GROUP_Description,
  GROUP_MemberCount,
  GROUP_Color,
  GROUP_Display,
  GROUP_TargetCounts,
  GROUP_TargetDutyCount,
  GROUP_TargetDayDutyCount,
  GROUP_TargetNightDutyCount,
  GROUP_RegisterMembers,
  GroupPage,
  GROUPS_Title,
  GROUPS_Target,
  GROUPS_NewMembers,
  GRID_NUMBER_RESULT,
  GRID_EXCEL_EXPORT,
  HANGFIRE_Start,
  HANGFIRE_Stop,
  HomePage,
  HOME_Title,
  TRANSFER_MODULE_Title,
  IS_ACTIVE,
  Lastname,
  LEVEL_Accept,
  LEVEL_Reject,
  LOGIN_Login,
  LOGIN_Password,
  LOGIN_ChangePassword,
  LOGIN_ForgotPassword,
  LOGIN_ResetPassword,
  LOGIN_EmailAPB,
  LOGIN_PreferredBrowsers,
  MESSAGE_TabTitle,
  PHARMACY_CalendarComparison,
  MESSAGE_Title,
  MESSAGE_TestEmailAddress,
  MESSAGE_Date,
  MESSAGE_Content,
  MESSAGE_Sender,
  MESSAGE_Recipient,
  MESSAGE_Type,
  MESSAGE_NewMessage,
  MESSAGE_TestMessage,
  MESSAGE_NewAnswer,
  MESSAGE_RECIPIENTS_All,
  MESSAGE_RECIPIENTS_Affiliates_1,
  MESSAGE_RECIPIENTS_Affiliates_3,
  MESSAGE_RECIPIENTS_Affiliates_All,
  MESSAGE_RECIPIENTS_Group,
  MESSAGE_RECIPIENTS_Neighbors,
  MESSAGE_RECIPIENTS_Neighbors_radius,
  MESSAGE_RECIPIENTS_PharmaciesOnDuty,
  MESSAGE_RECIPIENTS_DutyDate,
  MESSAGE_RECIPIENTS_One,
  MESSAGE_RECIPIENTS_Several,
  MESSAGE_RECIPIENTS_DayOnlyDuty,
  MESSAGE_RECIPIENTS_NightOnlyDuty,
  MESSAGE_RECIPIENTS_DayNightDuty,
  MULTI_CALENDAR_MsgYouHaveReachedQuota,
  MULTI_CALENDAR_ErrorMsgTooManyBlackPoints,
  MULTI_CALENDAR_ErrorMsgTooManyBlackPointsOnBankHolidays,
  MULTI_CALENDAR_ErrorMsgTooManyBlackPointsOnWeekends,
  MULTI_CALENDAR_ErrorMsgTooManyEconomicBlackPoints,
  MULTI_CALENDAR_ErrorMsgEncodingNotOpenForThisDate,
  MULTI_CALENDAR_InfoMsgAlreadyExempted,
  MULTI_CALENDAR_TOOLBOX_EncodingIsPossible,
  MULTI_CALENDAR_Toolbox,
  MULTI_CALENDAR_Legend,
  MULTI_CALENDAR_TOOLBOX_BankHoliday,
  MULTI_CALENDAR_TOOLBOX_BankHolidayDutyOffRequest,
  MULTI_CALENDAR_TOOLBOX_BlackPointEconomic,
  MULTI_CALENDAR_TOOLBOX_BlackPointHoliday,
  MULTI_CALENDAR_TOOLBOX_BlackPointSick,
  MULTI_CALENDAR_TOOLBOX_BlackPointSpecial,
  MULTI_CALENDAR_TOOLBOX_BlackPointSpecialDeactivate,
  MULTI_CALENDAR_TOOLBOX_DutyDay,
  MULTI_CALENDAR_TOOLBOX_DutyDayNight,
  MULTI_CALENDAR_TOOLBOX_DutyNigth,
  MULTI_CALENDAR_TOOLBOX_Erase,
  MULTI_CALENDAR_TOOLBOX_Inactive,
  MULTI_CALENDAR_TOOLBOX_Modification,
  MULTI_CALENDAR_TOOLBOX_Today,
  MULTI_CALENDAR_TOOLBOX_PreviousYear,
  MULTI_CALENDAR_TOOLBOX_NextYear,
  MULTI_CALENDAR_TOOLBOX_BlackPointEncodingStatus,
  MULTI_CALENDAR_TOOLBOX_BlackPointEncodingOpen,
  MULTI_CALENDAR_TOOLBOX_BlackPointEncodingClosed,
  MULTI_CALENDAR_TOOLBOX_NrBlackPointInfo,
  MULTI_CALENDAR_TOOLBOX_NrBlackPoint,
  MULTI_CALENDAR_TOOLBOX_NrFreeBankHolidayBalance,
  MULTI_CALENDAR_TOOLBOX_NrFreeWeekendBalance,
  MULTI_CALENDAR_TOOLBOX_NrFreeEconomicBlackpoint,
  MULTI_CALENDAR_TOOLBOX_QuotaHelp,
  MULTI_CALENDAR_NoSecretariatSelected,
  MULTI_CALENDAR_REMOVE_EXEMPTION_TITLE,
  MULTI_CALENDAR_REMOVE_EXEMPTION_CONTENT,
  MUNICIPALITY_Id,
  MUNICIPALITY_Choose,
  MUNICIPALITY_EntityNameFr,
  MUNICIPALITY_EntityNameNl,
  MUNICIPALITY_Edit,
  MUNICIPALITY_PostalCode,
  MUNICIPALITY_Ins5Code,
  MUNICIPALITY_INS6Code,
  MUNICIPALITY_IsMain,
  MUNICIPALITY_Population,
  MUNICIPALITY_MainMunicipalityFr,
  MUNICIPALITY_MainMunicipalityNl,
  MUNICIPALITY_Selection_Message,
  PROTECTION_StartDate,
  PROTECTION_EndDate,
  PROTECTION_Duration,
  PROTECTION_Range,
  PROTECTION_Status,
  PROTECTION_Type,
  MY_PHARMACY,
  NONE,
  SelectADay,
  OneDay,
  OneMonth,
  OneWeek,
  OneYear,
  Password,
  PHARMACIES_Address,
  PHARMACIES_ZipCode,
  PHARMACIES_City,
  PHARMACIES_Municipality,
  PHARMACIES_ApbNum,
  PHARMACIES_BackToList,
  PHARMACIES_PharmacyName,
  PHARMACIES_Title,
  PHARMACIES_Density,
  PHARMACIES_Group,
  PHARMACIES_Groups,
  PHARMACIES_Anchor,
  PHARMACIES_Distance,
  PHARMACIES_Level,
  PHARAMCIES_Secretariat,
  PHARAMCIES_Secretariats,
  PHARMACIES_Status,
  PHARMACIES_Pharmacist,
  PHARMACIES_ActivityStatus,
  PHARMACIES_Active,
  PHARMACIES_Inactive,
  PHARMACIES_All_F,
  PHARMACIES_All_M,
  PHARMACIES_Zone,
  PHARMACIES_Zero,
  PHARMACIES_Limitrophes,
  PHARMACIES_One,
  PHARMACIES_Three,
  PHARMACIES_LoadList,
  PHARMACY,
  PHARMACY_ApbNr,
  PHARMACY_BlackPointList,
  PHARMACY_CALENDAR_Comment,
  PHARMACY_Capital,
  PHARMACY_CheckDutyOffRequests,
  PHARMACY_Density,
  PHARMACY_DayMinDistance,
  PHARMACY_DayMaxDistance,
  PHARMACY_NightMinDistance,
  PHARMACY_NightMaxDistance,
  PHARMACY_Details,
  PHARMACY_DUTIES_Explanation_1,
  PHARMACY_DUTIES_Date,
  PHARMACY_DUTIES_Hour,
  PHARMACY_DUTIES_Pharmacy,
  PHARMACY_DUTIES_ApbNumber,
  PHARMACY_DUTIES_Address,
  PHARMACY_DUTIES_Phone,
  PHARMACY_DutyCalendar,
  PHARMACY_DutyCalendarComparator,
  PHARMACY_DutyList,
  PHARMACY_DutyRoster,
  PHARMACY_DUTY_ROSTER_AllRoster,
  PHARMACY_DUTY_ROSTER_Download,
  PHARMACY_DUTY_ROSTER_Print,
  PHARMACY_DUTY_ROSTER_From,
  PHARMACY_DUTY_ROSTER_NumWeek,
  PHARMACY_DUTY_ROSTER_RosterNextWeek,
  PHARMACY_DUTY_ROSTER_RosterThisWeek,
  PHARMACY_DUTY_ROSTER_To,
  PHARMACY_IsContributing,
  PHARMACY_IsActive,
  PHARMACY_Language,
  PHARMACY_Latitude,
  PHARMACY_X_Lambert2008,
  PHARMACY_Level,
  PHARMACY_Longitude,
  PHARMACY_Y_Lambert2008,
  PHARMACY_Anchor,
  PHARMACY_Zone,
  PHARMACY_Group,
  PHARMACY_Map,
  PHARMACY_DutyMap,
  PHARMACY_Mobile,
  PHARMACY_Neighborhood,
  PHARMACY_Phone,
  PHARMACY_ReceivesSms,
  PHARMACY_Title,
  PHARMACY_RefreshGeoData,
  PHARMACY_PrefDayOff,
  PHARMACY_PrefDayOn,
  PUSH_NOTIFICATION_Push,
  PharmacyPage,
  PlannerPage,
  PLANNER_Title,
  PLANNER_FILE_LOADING_MODAL_TITLE,
  PLANNER_FILE_SUCCESSFULLY_IMPORT,
  PLANNER_ERROR_MESSAGE,
  QUICK_DUTY_PAGE,
  CALENDAR_COMPARISON_PAGE,
  Role,
  ROSTER_COPYBP,
  ROSTER_COPYLVL1DUTIES,
  ROSTER_CopyBPOrDuties,
  ROSTER_CheckDutyOffRequests,
  ROSTER_ExplainScore,
  ROSTER_FileLinesLimit,
  ROSTER_ShowMatches,
  ROSTER_ShowExplanation,
  ROSTER_ShowIndictments,
  ROSTER_GetScore,
  ROSTER_GetStatus,
  ROSTER_ReloadSolution,
  ROSTER_InitializeDownloadPharmacyData,
  ROSTER_InitializeDownloadAdjacentPharmacyData,
  ROSTER_Resume,
  ROSTER_SaveDutyAssignments,
  ROSTER_PublishPlanning,
  ROSTER_DownloadDutyAssignments,
  ROSTER_DownloadDutyAssignmentsButton,
  ROSTER_ReplicateLevel1DutyAssignments,
  ROSTER_UploadDuties,
  ROSTER_DownloadDutyExchanges,
  ROSTER_DownloadDutyExchangesButton,
  ROSTER_DownloadAddedDutyAssignmentsButton,
  ROSTER_S1,
  ROSTER_S2,
  ROSTER_SavePlanningData,
  ROSTER_SemesterNotSelected,
  ROSTER_SemesterSelected,
  ROSTER_SerializeSolution,
  ROSTER_Start,
  ROSTER_Stop,
  ROSTER_Suspend,
  ROSTER_Reconnect,
  ROSTER_Title,
  ROSTER_CheckMissingBlackPoints,
  ROSTER_CloseBlackPointEncoding,
  ROSTER_CalculateAnnualReviews,
  ROSTER_UploadPharmacies,
  ROSTER_CalculateNeighborhoods,
  ROSTER_ImportPharmacy,
  ROSTER_GoogleMapsMaxCalls,
  ROSTER_OpenPlannerPanel,
  ROSTER_SaveConfirmationTitle,
  ROSTER_SaveConfirmationText,
  ROSTER_PublishConfirmationTitle,
  ROSTER_PublishConfirmationText,
  ROSTER_DeserializeConfirmationTitle,
  ROSTER_DeserializeConfirmationText,
  ROSTER_Year,
  SearchAPBOrNamePlaceholder,
  SearchPharmacyAddressPlaceholder,
  SECRETARIAT,
  SECRETARIAT_Title,
  SECRETARIAT_Add,
  SECRETARIAT_Address,
  SECRETARIAT_Code,
  SECRETARIAT_Edit,
  SECRETARIAT_Language,
  SECRETARIAT_LinkPharmacy,
  SECRETARIAT_Name,
  SECRETARIAT_DASHBOARD_Title,
  SECRETARIAT_DASHBOARD_BlackPointTitle,
  SECRETARIAT_DASHBOARD_ExchangeTitle,
  SECRETARIAT_DASHBOARD_BankHolidayTitle,
  SECRETARIAT_DASHBOARD_BankHolidayLabel,
  SECRETARIAT_DASHBOARD_BankHolidayDateLabel,
  SECRETARIAT_DASHBOARD_SelectBankHoliday,
  SECRETARIAT_DASHBOARD_PlanningTitle,
  SECRETARIAT_DASHBOARD_AnnualReviewTitle,
  SECRETARIAT_DASHBOARD_PrefsTitle,
  SECRETARIAT_DASHBOARD_Year,
  SECRETARIAT_DASHBOARD_Status,
  SECRETARIAT_DASHBOARD_EditStatus,
  SECRETARIAT_DASHBOARD_CreateStatus,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_ActualDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AverageDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Balance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AbsBalance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Ratio,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_PrevActualDayDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_ActualDayDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AverageDayDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_DayBalance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AbsDayBalance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_DayRatio,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_PrevActualNightDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_ActualNightDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AverageNightDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_NightBalance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AbsNightBalance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_NightRatio,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Validate,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Validated,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Calculate,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Calculated,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_All,
  MISSING_BLACKPOINTS_NumberBP,
  MISSING_BLACKPOINTS_Title,
  MISSING_BLACKPOINTS_Filter,
  MISSING_BLACKPOINTS_FilterComplete,
  MISSING_BLACKPOINTS_FilterPartial,
  MISSING_BLACKPOINTS_FilterEmpty,
  MISSING_BLACKPOINTS_FilterAll,
  SecretariatPage,
  SECRETARIATS_Title,
  TransferPage,
  Pharmamove,
  TRANSFER_AddCircleDialogTitle,
  TRANSFER_Address,
  TRANSFER_Calculate,
  TRANSFER_CalculateNewCoordinates,
  TRANSFER_Coordinates,
  TRANSFER_Explore,
  TRANSFER_ProtectionTabTitle,
  TRANSFER_SimpleTransferTabTitle,
  TRANSFER_SimpleFusionTabTitle,
  TRANSFER_TransferWithFusionTabTitle,
  TRANSFER_RefDataTabTitle,
  TRANSFER_RequestTabTitle,
  TRANSFER_MunicipalityUpload,
  TRANSFER_MunicipalityCreation,
  TRANSFER_MunicipalityEdition,
  TRANSFER_PermanentProtection,
  TRANSFER_PharmacyToClose,
  TRANSFER_PharmacyToTransfer,
  TRANSFER_PharmacyToKeep,
  TRANSFER_PharmacyNbrPharmacies,
  TRANSFER_PharmacyEntity,
  TRANSFER_Lambert,
  TRANSFER_LatLong,
  TRANSFER_NewAddress,
  TRANSFER_NewLambert2008Coordinates,
  TRANSFER_InsidePolygon,
  TRANSFER_InsideCircle,
  TRANSFER_Radius,
  TRANSFER_PolygonNotOptimized,
  TRANSFER_Show100mCircle,
  TRANSFER_ShowCircles,
  TRANSFER_ShowPerpendiculars,
  TRANSFER_ShowPolygons,
  TRANSFER_ShowProtectionCircles,
  TRANSFER_ShowDefaultProtectionCircles,
  TRANSFER_ShowTemporaryProtectionCircles,
  TRANSFER_ShowIntersection,
  TRANSFER_ShowRadius,
  TRANSFER_SelectedLat,
  TRANSFER_SelectedLng,
  TRANSFER_SelectedRadius,
  TRANSFER_SwitchSearchByLambert2008,
  TRANSFER_TemporaryProtection,
  TRANSFER_OutsideProtectedCircles,
  TRANSFER_InsideMoveCircles,
  TRANSFER_NewCoordinates,
  TRANSFER_Distance,
  TRANSFER_within100Meters,
  TRANSFER_ClosestPharmacy,
  TRANSFER_NbrMinPharmacies,
  TRANSFER_NbrMaxPharmacies,
  TRANSFER_NbrInhabitantsInZone,
  TRANSFER_UploadZipCodesStatbel,
  TRANSFER_UploadZipCodesBpost,
  TRANSFER_UploadMunicipalities,
  TRANSFER_UploadZipCodes,
  TRANSFER_UploadPopulations,
  TRANSFER_NeighborCount,
  TRANSFER_EstimateNeighborCount,
  TRANSFER_PerpendicularLength,
  TRANSFER_CHOOSE_A_Municipality,
  TRANSFER_ZoomClose,
  TRANSFER_ZoomNeighbors,
  TRANSFER_ZoomPharmacy,
  TRANSFER_ZoomPharmacyKeep,
  TRANSFER_ZoomHalfHalf,
  TRANSFER_ZoomDestination,
  TRANSFER_ZoomPolygon,
  TRANSFER_REQUEST_requestDate,
  TRANSFER_REQUEST_decisionDate,
  TRANSFER_REQUEST_decision,
  TRANSFER_REQUEST_firstPublishDate,
  TRANSFER_REQUEST_firstPublishAfterDecisionDate,
  TRANSFER_REQUEST_initialAddress,
  TRANSFER_REQUEST_initialZipCode,
  TRANSFER_REQUEST_initialCity,
  TRANSFER_REQUEST_newAddress,
  TRANSFER_REQUEST_newZipCode,
  TRANSFER_REQUEST_newCity,
  TRANSFER_REQUEST_procedure,
  ANALYSIS_MENU_ENTRY,
  ANALYSIS_MAIN_TITLE,
  ANALYSIS_PROBLEMS,
  ANALYSIS_CLICK_SEMESTER,
  ANALYSIS_PERIOD,
  ANALYSIS_OFFSET,
  ANALYSIS_PLANNINGID,
  ANALYSIS_PREVPLANNINGID,
  ANALYSIS_STATUS,
  ANALYSIS_START,
  ANALYSIS_END,
  ANALYSIS_PERIOD_UNTIL,
  ANALYSIS_GLOBAL_PERF,
  ANALYSIS_PERF,
  ANALYSIS_GLOBAL_PERF_COMMENT,
  ON_A_TOTAL_OF,
  AMONG_WHICH,
  LEVEL3,
  DUTIES,
  PHARMACIES,

  TOO_CLOSE_DUTIES,
  TOO_CLOSE_DUTIES_DETAILS,
  TOO_CLOSE_DUTIES_DETAILS1,
  TOO_CLOSE_DUTIES_PHARMACYID,
  TOO_CLOSE_DUTIES_PHARMACY,
  TOO_CLOSE_DUTIES_PHARMACY_NAME,
  TOO_CLOSE_DUTIES_PHARMACY_GROUP,
  TOO_CLOSE_DUTIES_ECART,
  TOO_CLOSE_DUTIES_DATE1,
  TOO_CLOSE_DUTIES_DATE2,
  TOO_CLOSE_DUTIES_TOTAL,

  ABNORMAL_DUTY_COUNTS,
  ABNORMAL_DUTY_COUNTS_DETAILS,
  ABNORMAL_DUTY_COUNTS_PHARMACY,
  ABNORMAL_DUTY_COUNTS_APBNUMBER,
  ABNORMAL_DUTY_COUNTS_NAME,
  ABNORMAL_DUTY_COUNTS_COUNT,
  ABNORMAL_DUTY_COUNTS_TARGET_COUNT,
  ABNORMAL_DUTY_COUNTS_DAY_COUNT,
  ABNORMAL_DUTY_COUNTS_DAY_TARGET_COUNT,
  ABNORMAL_DUTY_COUNTS_NIGHT_COUNT,
  ABNORMAL_DUTY_COUNTS_NIGHT_TARGET_COUNT,
  DUTY_COUNT_CHANGES_TITLE,
  DUTY_COUNT_CHANGES_LIST_TITLE,
  DUTY_COUNT_CHANGES_GRAPHS_TITLE,
  DUTY_COUNT_CHANGES_PHARMACYID,
  DUTY_COUNT_CHANGES_PHARMACYID_TOOLTIP,
  DUTY_COUNT_CHANGES_APBNUMBER,
  DUTY_COUNT_CHANGES_GROUP_TARGET,
  DUTY_COUNT_CHANGES_GROUP_TARGET_DIFFERENCE,
  DUTY_COUNT_CHANGES_GROUP_DAY_TARGET,
  DUTY_COUNT_CHANGES_GROUP_NIGHT_TARGET,
  DUTY_COUNT_CHANGES_PHARMACY_NAME,
  DUTY_COUNT_CHANGES_PREVALL,
  DUTY_COUNT_CHANGES_PREVDAY,
  DUTY_COUNT_CHANGES_PREVDAYONLY,
  DUTY_COUNT_CHANGES_PREVDAYONLY_TOOLTIP,
  DUTY_COUNT_CHANGES_PREVNIGHT,
  DUTY_COUNT_CHANGES_PREVNIGHT_TOOLTIP,
  DUTY_COUNT_CHANGES_CURRALL,
  DUTY_COUNT_CHANGES_CURRDAY,
  DUTY_COUNT_CHANGES_CURRDAYONLY,
  DUTY_COUNT_CHANGES_CURRDAYONLY_TOOLTIP,
  DUTY_COUNT_CHANGES_CURRNIGHT,
  DUTY_COUNT_CHANGES_CURRNIGHT_TOOLTIP,
  DUTY_COUNT_CHANGES_DIFFERENCE,
  DUTY_COUNT_CHANGES_CURRENT_RATIO,
  DUTY_COUNT_CHANGES_PREVIOUS_RATIO,
  DUTY_COUNT_CHANGES_DIFFERENCE_TOOLTIP,
  DUTY_COUNT_CHANGES_CURRNBR_TOOLTIP,
  DUTY_COUNT_CHANGES_PREVNBR_TOOLTIP,
  DUTY_COUNT_CHANGES_CURRRATIO_TOOLTIP,
  DUTY_COUNT_CHANGES_PREVRATIO_TOOLTIP,
  DUTY_COUNT_CHANGES_EXPLANATION_1,
  DUTY_COUNT_CHANGES_EXPLANATION_2,
  DAYS,
  OR,
  FAKE,
  SPECIALISSUES_TITLE,
  SPECIALISSUES_BLACKPOINTTRANSGRESSIONS,
  SPECIALISSUES_GROUPTRANSGRESSIONS,
  SPECIALISSUES_GROUPTRANSGRESSIONSBYDATE,
  SPECIALISSUES_DATE,
  SPECIALISSUES_TYPE,
  SPECIALISSUES_NAME,
  GROUPANALYSIS_TITLE,
  GROUPANALYSIS_CALCULATE,
  GROUPANALYSIS_DYNAMIC_TRANSGRESSIONS,
  GROUPANALYSIS_GROUP_AVERAGE_DUTY_COUNTS,
  GROUPANALYSIS_GROUP_TRANSGRESSIONS_BY_DATE,
  GROUPANALYSIS_GROUP,
  GROUPANALYSIS_MEMBERS,
  GROUPANALYSIS_TARGET,
  GROUPANALYSIS_COUNT,
  GROUPANALYSIS_AVERAGE,
  UNBALANCED_NEIGHBORS_TITLE,
  UNBALANCED_NEIGHBORS_LIST_TITLE,
  UNBALANCED_NEIGHBORS_GRAPHS_TITLE,
  UNBALANCED_NEIGHBORS_COMMENTS,
  UNBALANCED_NEIGHBORS_DETAILS,
  UNBALANCED_NEIGHBORS_PHARMACYID,
  UNBALANCED_NEIGHBORS_PHARMACY_APB,
  UNBALANCED_NEIGHBORS_PHARMACY_NAME,
  UNBALANCED_NEIGHBORS_FRIDAYS,
  UNBALANCED_NEIGHBORS_FRIDAY_STATS,
  UNBALANCED_NEIGHBORS_FRIDAYS_TOOLTIP,
  UNBALANCED_NEIGHBORS_FRIDAYS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_SATURDAYS,
  UNBALANCED_NEIGHBORS_SATURDAY_STATS,
  UNBALANCED_NEIGHBORS_SATURDAYS_TOOLTIP,
  UNBALANCED_NEIGHBORS_SATURDAYS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_SUNDAYS,
  UNBALANCED_NEIGHBORS_SUNDAY_STATS,
  UNBALANCED_NEIGHBORS_SUNDAYS_TOOLTIP,
  UNBALANCED_NEIGHBORS_SUNDAYS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_HOLIDAYS,
  UNBALANCED_NEIGHBORS_YEAR_HOLIDAYS,
  UNBALANCED_NEIGHBORS_HOLIDAY_STATS,
  UNBALANCED_NEIGHBORS_HOLIDAYS_TOOLTIP,
  UNBALANCED_NEIGHBORS_HOLIDAYS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_NIGHTS,
  UNBALANCED_NEIGHBORS_NIGHT_STATS,
  UNBALANCED_NEIGHBORS_NIGHTS_TOOLTIP,
  UNBALANCED_NEIGHBORS_NIGHTS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_DAYS,
  UNBALANCED_NEIGHBORS_DAY_STATS,
  UNBALANCED_NEIGHBORS_DAYS_TOOLTIP,
  UNBALANCED_NEIGHBORS_DAYS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_TOTAL,
  UNBALANCED_NEIGHBORS_TOTAL_STATS,
  UNBALANCED_NEIGHBORS_TOTAL_TOOLTIP,
  UNBALANCED_NEIGHBORS_TOTAL_STAT_TOOLTIP,

  INSUFICIENT_GEO_COVERAGE,

  ANALYSIS_RULES,
  ANALYSIS_SCORES,
  ANALYSIS_SCORES_TIMESTAMP,
  ANALYSIS_SCORES_ID,
  ANALYSIS_SCORES_RUNID,
  ANALYSIS_SCORES_PLANNINGID,
  ANALYSIS_SCORES_STATUS,
  ANALYSIS_SCORES_START,
  ANALYSIS_SCORES_END,
  ANALYSIS_SCORES_NAME,
  ANALYSIS_SCORES_DESCRIPTION,
  ANALYSIS_SCORES_HARD,
  ANALYSIS_SCORES_MED,
  ANALYSIS_SCORES_SOFT,

  ANALYSIS_MATCHES,
  ANALYSIS_MATCHES_RULE,
  ANALYSIS_MATCHES_HARD,
  ANALYSIS_MATCHES_MED,
  ANALYSIS_MATCHES_SOFT,
  ANALYSIS_MATCHES_TRANSGRESSIONS,
  ANALYSIS_MATCHES_PREV,
  ANALYSIS_MATCHES_CURR,
  ANALYSIS_MATCHES_NEXT,
  ANALYSIS_MATCHES_APPNUMBER,
  ANALYSIS_MATCHES_NAME,
  ANALYSIS_MATCHES_COUNT,

  ANALYSIS_TRANSGRESSIONS,
  ANALYSIS_TRANSGRESSIONS_ID,
  ANALYSIS_TRANSGRESSIONS_DETAIL,
  PHARMACY_LINKS_NOTICE,
  PHARMACY_LINKS2_NOTICE,
  PHARMACY_FILTER_NOTICE,
  SCORE_LINKS_NOTICE,

  SUBMIT,
  REFRESH,

  Today,
  UNAVAILABILITY_Title,
  UNAVAILABILITY_LoginStatus,
  UNAVAILABILITY_AuthorizeLogin,
  UNAVAILABILITY_LimitLogin,
  UNAVAILABILITY_MinimalLogin,
  USER,
  USER_Title,
  USER_Impersonate,
  Username,
  UserPage,
  USERS_Title,
}
